import React from "react";
import {
  Box,
  Flex,
  Avatar,
  Heading,
  Text,
  useColorModeValue
} from "@chakra-ui/react";

const ProfileHeader = ({ user }) => {
  const bgCard = useColorModeValue("white", "whiteAlpha.100");

  return (
    <Box bg={bgCard} p={6} mb={6} borderRadius="lg" boxShadow="sm">
      <Flex align="center">
        <Avatar
          size="xl"
          name={`${user.firstName ?? ''} ${user.lastName ?? ''}`}
          src={user.imageUrl}
          mr={6}
        />
        <Box>
          <Heading as="h2" fontSize="2xl" mb={1}>
            {user.username}
          </Heading>
          <Text color="gray.500">{user.email}</Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default ProfileHeader;
